import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FilterOptions } from '@shared/interfaces/filterOptions.interface';
import { catchError, map, Observable, of } from 'rxjs';
import { ApiLeaseService } from '../api/api-lease.service';

@Injectable({
  providedIn: 'root'
})
export class LeaseService {
  entity!: FormGroup
  formMethod = 'CREATE'
  assets: { label: string; value: string; }[] = []
  quotations: { label: string; value: string; }[] = []
  clients: { label: string; value: string; entity: string; rfc?: string }[] = []
  documentTypes: { label: string; value: string; }[] = [
    { label: "Persona Moral", value: "LegalEntityDocs" },
    { label: "Persona Física", value: "NaturalEntityDocs" }
  ]
  documentType?: string

  constructor(
    private fb: FormBuilder,
    private apiLeaseService: ApiLeaseService
  ) {
    this.searchClients('')
  }

  newEntity() {
    switch (this.formMethod) {
      case 'CREATE':
        this.entity = this.fb.group({
          client: ['', [Validators.required]],
          quotationParametersId: ['', [Validators.required]],
          documentType: [this.documentType],
        })
        break;
    }
  }

  getClientName(id: string) {
    return this.clients.find(c => c.value === id)?.label
  }

  getAssetName(id: string) {
    return this.assets.find(c => c.value === id)?.label
  }

  getQuotationParametersName(id: string) {
    return this.quotations.find(c => c.value === id)?.label
  }

  getDocumentTypeName(id: string) {
    return this.documentTypes.find(c => c.value === id)?.label
  }

  onSelectClient(event: any) {
    const selectedClient = this.clients.find(client => client.value === event.value);
    
    if (selectedClient) {
      const documentType = selectedClient.entity === 'Moral' ? 'LegalEntityDocs' : 'NaturalEntityDocs';
      this.entity.patchValue({ documentType: documentType });
  
      this.fetchQuotations({ 
        page: 1,
        limit: 10,
        filters: {
          client: { value: selectedClient.value, matchMode: 'equals' },
          status: { value: 'proposal', matchMode: 'equals' } 
        } });
    }
  }

  // Búsqueda server-side de clientes (nombre O RFC). Preserva el cliente ya seleccionado
  // en `clients` aunque no venga en los resultados, para que su etiqueta no desaparezca del
  // dropdown al cambiar el término de búsqueda.
  searchClients(q = ''): void {
    const selectedId = this.entity?.get('client')?.value
    const selected = selectedId ? this.clients.find(c => c.value === selectedId) : null

    this.apiLeaseService.searchClients(q).subscribe(
      (clients) => {
        const merged = [...clients]
        if (selected && !merged.some(c => c.value === selected.value)) merged.unshift(selected)
        this.clients = merged;
      },
      (error) => {
        console.error('Error al buscar los clientes:', error);
      }
    );
  }

  fetchQuotations(filterOptions: FilterOptions): void {
    filterOptions.limit = 1000;

    this.apiLeaseService.fetchQuotations(filterOptions).subscribe(
      (quotations) => {
        this.quotations = quotations;
      },
      (error) => {
        console.error('Error al obtener las cotizaciones:', error);
      }
    );
  }
  
}
